'use client';
import { noop } from '@capsicum/common';
import { type ComponentType, useEffect } from 'react';

// Issue: https://github.com/microsoft/TypeScript-DOM-lib-generator/issues/1615
type ExtendedScreenOrientation = ScreenOrientation & { lock: (orientation: 'landscape' | 'portrait') => Promise<void> };

export function withForcedLandscape<T extends {}>(WrappedComponent: ComponentType<T>) {
	const Wrapped = (props: T) => {
		useEffect(() => {
			if (window.screen.orientation && (window.screen.orientation as ExtendedScreenOrientation).lock) {
				(window.screen.orientation as ExtendedScreenOrientation).lock('landscape').catch(noop);
			}

			return () => {
				if (window.screen.orientation && (window.screen.orientation as ExtendedScreenOrientation).lock) {
					(window.screen.orientation as ExtendedScreenOrientation).lock('portrait').catch(noop);
				}
			};
		}, []);

		return <WrappedComponent {...props} />;
	};

	Wrapped.displayName = `withForcedLandscape(${WrappedComponent.displayName || WrappedComponent.name})`;

	return Wrapped;
}
